module.exports = __webpack_public_path__ + "static/media/background_naturfagsmaraton.96c32ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/background_naturfagsmaraton.png
// module id = 1465
// module chunks = 0